var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-button',{on:{"click":_vm.handleUp}},[_vm._v("Up")]),_c('span',[_vm._v(_vm._s(_vm.vote))]),_c('b-button',{on:{"click":_vm.handleDown}},[_vm._v("Down")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }